/**
 * Share Progress Button
 * Reusable button to share progress from any feature
 */
import React, { useState } from 'react';
import { ShareIcon } from '@heroicons/react/24/outline';
import ProgressShareModal from './ProgressShareModal';
import { useUpgrade } from '../context/UpgradeContext';
import ProBadge from './upgrade/ProBadge';

const ShareProgressButton = ({ entityType, entityId, entityData, user, className = '' }) => {
    const [showModal, setShowModal] = useState(false);
    const { permissions, openUpgrade } = useUpgrade();

    const handleClick = () => {
      if (!permissions?.can_share_vision_card) {
        openUpgrade('share_vision');
        return;
      }
      setShowModal(true);
    };

    return (
      <>
      <button
        type="button"
        onClick={handleClick}
        className={`btn-primary flex items-center gap-2 ${className}`}
      >
        <ShareIcon className="w-4 h-4" />
        <span>Share Progress</span>
        {!permissions?.can_share_vision_card && <ProBadge feature="share_vision" />}
      </button>

      <ProgressShareModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        entityType={entityType}
        entityId={entityId}
        entityData={entityData}
        user={user}
      />
    </>
  );
};

export default ShareProgressButton;
